import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from '@/i18n';

Vue.use(Vuetify);

// Os textos do Vuetify seguem o idioma do cardápio (src/i18n).
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: (localStorage.dark && localStorage.dark === 'true'),
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        accent: '#6565bf',
      },
      dark: {
        accent: '#6565bf',
      },
    },
  },
});
